// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3aJpL{padding:2.5rem 0}._3k40L{margin-bottom:1.5rem;font-size:24px;font-size:1.5rem;font-weight:500;line-height:30px;line-height:1.875rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._3k40L{font-size:1.25rem;line-height:1.5625rem}}._2pJH5{padding-right:2rem;background-color:#fff;height:472.96px;height:29.56rem;overflow:scroll}", ""]);
// Exports
exports.locals = {
	"root": "_3aJpL",
	"title": "_3k40L",
	"list": "_2pJH5"
};
module.exports = exports;
